import * as datastore from '@/datastore'

export interface Brand_PantryItem extends datastore.Reference {
	brandId: string
	pantryItemId: string
}

export const defaultBrand_PantryItem: Readonly<Brand_PantryItem> = {
	$id: '',
	brandId: '',
	pantryItemId: '',
}
